import React from 'react';
import ItemsView from '../components/ItemsView';

const FramesView = () => <ItemsView type="Frame" />;

export default FramesView;
